import React, { useEffect, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDelete } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";
import { useQuery } from "@tanstack/react-query";
import {
  deleteStaff,
  deleteSubTask,
  getSubTaskTempList,
  getTaskTempList,
} from "../../../../apiCall";
import toast from "react-hot-toast";
import { FormateDate, formatTimeDuration } from "../../../../utils/FormateDate";

import { ExtractDays } from "../../../../utils/ExtractDays";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useStateValue } from "../../../../StateProvider";
import { ConfirmationModal } from "../../../../components/Modals/ConfirmationModal";
import TruncateText from "../../../../utils/TruncateText";

const SubTaskList = ({
  setIsSaveAndAddSubTask,
  setIsSaveAndEditSubTask,
  setEditSubTaskId,
  projectTempId,
  tName,
  pName,
}) => {
  const [{ sysConfig }, dispatch] = useStateValue();
  const [searchParams] = useSearchParams();
  const subTaskId = searchParams.get("subTaskId");
  const { temId, projectId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const fetchSubTask = async () => {
    // Perform the API call to fetch company info
    try {
      dispatch({ type: "SET_LOADING", status: true });

      const response = await getSubTaskTempList(temId);
      if (response?.status === 200) {
        setTaskTempList(response.data.data);
        setFilteredData(response.data.data);
      } else if(response?.response) {
        toast.error(response.response.data.status);
      }
      dispatch({ type: "SET_LOADING", status: false });

      return response;
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };
  const removeSubTask = async (id) => {
    // Perform the API call to fetch company info
    try {
      const response = await deleteSubTask(id);
      console.log(response);
      if (response?.status === 200) {
        refetch();
        toast.success(response.data.message);
      } else if(response?.response) {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };

  const {
    isLoading,
    data: subTaskListData,
    refetch,
  } = useQuery({
    queryKey: ["sub-task-temp-list"],
    queryFn: fetchSubTask,
    enabled: temId ? true : false,
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  const [taskTempList, setTaskTempList] = useState([]);

  // ********************************************************************* filter Data *************************************************
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState([]);
  const [currentItems, setCurrentItems] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    filterData(searchQuery);
  }, [searchQuery]);
  useEffect(() => {
    const startIdx =
      (currentPage - 1) * Number(sysConfig["Rows in MultiLine List"]);
    const totalPageCount = Math.ceil(
      filteredData.length / Number(sysConfig["Rows in MultiLine List"])
    );
    setCurrentItems(
      filteredData.slice(
        startIdx,
        startIdx + Number(sysConfig["Rows in MultiLine List"])
      )
    );
    setTotalPages(totalPageCount);
    if (totalPageCount !== 0 && totalPageCount < currentPage) {
      setCurrentPage(totalPageCount);
    }
  }, [currentPage, filteredData]);

  const filterData = (query) => {
    let filtered = taskTempList;

    if (query) {
      filtered = filtered.filter(
        (item) =>
          item.Dscr.toLowerCase().includes(query) ||
          item.Name.toLowerCase().includes(query)
        //|| item.Mobile.includes(query)
      );
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  useEffect(() => {
    if (subTaskId) {
      const targetIndex = filteredData.findIndex((item) => {
        return item.ID === parseInt(subTaskId);
      });
      console.log(targetIndex, filteredData);
      const pageNumber =
        Math.floor(targetIndex / Number(sysConfig["Rows in MultiLine List"])) +
        1;
      console.log("page number", filteredData, targetIndex, pageNumber);
      setCurrentPage(pageNumber);
    }
  }, [subTaskId, filteredData]);
  const removeSelection = () => {
    if (subTaskId) {
      navigate(location.pathname, { replace: true });
    }
  };

  // const [staffList, setStaffList] = useState(staffListData?.status === 200 ?staffListData?.data:[]);
  // ************************************************************* Confirmation modal start **********************************

  const [confirmationShow, setConfirmationShow] = useState(false);
  const [funHandler, setFunHandler] = useState();
  const handleConfirmationClose = () => {
    setConfirmationShow(false);
  };
  const handleConfirmationShow = () => setConfirmationShow(true);
  return (
    <div className="row" key="Sd">
      <div className="col-12">
        {/* card */}
        <div className="card">
          <div className="card-header  ">
            <div className="row justify-content-end">
              <div className="col-lg-3 col-md-5 d-flex justify-content-end ">
                {temId ? (
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => {
                      // if (projectId || projectTempId) {
                      //   navigate(
                      //     `/project/${projectTempId}/${pName}/add/subtask/${temId}/${tName}`
                      //   );
                      // } else {
                      //   navigate(`/add/subtask/${temId}/${tName}`);
                      // }
                      setIsSaveAndAddSubTask(true);
                    }}
                  >
                    + Save and Add Sub Task
                  </button>
                ) : (
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => {
                      setIsSaveAndAddSubTask(true);
                    }}
                  >
                    + Save and Add Sub Task
                  </button>
                )}
              </div>
            </div>
          </div>
          {!isLoading ? (
            <>
              <div className="card-body">
                <div className="table-responsive table-card">
                  {currentItems.length > 0 ? (
                    <table className="table text-nowrap mb-0 responsive-table sub-table template-sub-table table-centered table-hover">
                      <thead className="table-light">
                        <tr>
                          <th className="ps-6">Srl</th>
                          <th className="ps-6">Name</th>
                          <th>Description</th>
                          <th>Approx Duration</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems.map((item, index) => (
                          <tr
                            key={`task-item-${item?.ID}-${index}`}
                            className={`${parseInt(subTaskId) === item?.ID
                              ? "table-primary"
                              : ""
                              }`}
                          >
                            <td data-label1="Srl"
                             style={{
                              width: "50px",
                              textWrap: "wrap",
                            }}>{item?.OrdNo}</td>
                            <td
                              className="name font-bold-md"
                              style={{
                                maxWidth: "300px",
                                textWrap: "wrap",
                              }}
                            >
                              <div className="truncate">

                                {item?.Name}
                              </div>
                            </td>
                            <td
                              className="name"
                              style={{
                                maxWidth: "300px",
                                textWrap: "wrap",
                              }}
                            >
                              <div className="truncate">{item?.Dscr}</div>

                              {/* {item?.Dscr} */}
                            </td>
                            <td data-label1="Approx Duration" style={{ width: "150px" }}>
                              {item?.AprxDuration === "0 days, 00:00"
                                ? "---"
                                : formatTimeDuration(item?.AprxDuration)}
                            </td>

                            <td data-label1="Action" style={{ width: "150px" }}>
                              <div className="d-flex">

                                <button
                                  className="btn btn-ghost btn-icon btn-sm rounded-circle texttooltip"
                                  data-template="editOne"
                                  onClick={() => {
                                    // navigate(`/update/subtask/${item.ID}`);
                                    setEditSubTaskId(item.ID);
                                    setIsSaveAndEditSubTask(true);
                                    // setEditSubTaskData(item);
                                    // setActiveTab("addUpdateSubTask");
                                    // setEditSubTaskData({...item ,TaskTmplID: editTaskTempData?.ID.toString()})
                                  }}
                                >
                                  <FaRegEdit size={18} />
                                  <div id="editOne" className="d-none">
                                    <span>Edit</span>
                                  </div>
                                </button>
                                <div
                                  className="btn btn-ghost btn-icon btn-sm rounded-circle texttooltip"
                                  data-template="trashOne"
                                  onClick={() => {
                                    handleConfirmationShow();
                                    removeSelection();
                                    setFunHandler({
                                      fun: removeSubTask,
                                      id: item?.ID,
                                      title: "delete sub task",
                                    });
                                  }}
                                >
                                  <MdOutlineDelete size={18} />
                                  <div id="trashOne" className="d-none">
                                    <span>Delete</span>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="m-5 fs-3">
                      <strong>No records found.!</strong>
                    </div>
                  )}
                </div>
              </div>
              {filteredData.length > 0 && (
                <div className="card-footer d-md-flex justify-content-between align-items-center">
                  <span>
                    Showing{" "}
                    {currentPage * Number(sysConfig["Rows in MultiLine List"]) -
                      Number(sysConfig["Rows in MultiLine List"]) +
                      1}{" "}
                    to{" "}
                    {currentPage *
                      Number(sysConfig["Rows in MultiLine List"]) >=
                      filteredData.length
                      ? filteredData.length
                      : currentPage *
                      Number(sysConfig["Rows in MultiLine List"])}{" "}
                    of {filteredData.length} entries
                  </span>
                  <nav className="mt-2 mt-md-0">
                    <ul className="pagination mb-0 ">
                      <li
                        className="page-item "
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (currentPage > 1) {
                            handlePageChange(currentPage - 1);
                            removeSelection();
                          }
                        }}
                      >
                        <div
                          className={`page-link ${currentPage === 1 ? "disabled" : ""
                            } `}
                        >
                          Previous
                        </div>
                      </li>
                      {Array(totalPages ? totalPages : 0)
                        .fill()
                        .map((item, index) => (
                          <li
                            style={{ cursor: "pointer" }}
                            className={`${currentPage === index + 1
                              ? "page-item active"
                              : "page-item"
                              } ${currentPage + 2 >= index + 1 &&
                                index + 1 > currentPage - 2
                                ? // currentPage - 2 < index + 1
                                "d-block"
                                : "d-none"
                              }`}
                            onClick={() => {
                              handlePageChange(index + 1);
                              removeSelection();
                            }}
                          >
                            <div className="page-link">{index + 1}</div>
                          </li>
                        ))}

                      {/* <li className="page-item">
                            <a className="page-link" href="#!">
                              2
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#!">
                              3
                            </a>
                          </li> */}
                      <li className="page-item">
                        <div
                          style={{ cursor: "pointer" }}
                          className={`page-link ${totalPages === currentPage ? "disabled" : ""
                            } `}
                          onClick={() => {
                            if (totalPages > currentPage) {
                              handlePageChange(currentPage + 1);
                              removeSelection();
                            }
                          }}
                        >
                          Next
                        </div>
                      </li>
                    </ul>
                  </nav>
                </div>
              )}
            </>
          ) : (
            <div className="m-5 fs-3">
              <strong>Fetching records..</strong>
            </div>
          )}
        </div>
      </div>
      <ConfirmationModal
        show={confirmationShow}
        onHide={handleConfirmationClose}
        funHandler={funHandler}
      />
    </div>
  );
};

export default SubTaskList;
